import { render, staticRenderFns } from "./5-in-1-water-sports-in-goa.vue?vue&type=template&id=03a9f36e&scoped=true"
import script from "./5-in-1-water-sports-in-goa.vue?vue&type=script&lang=js"
export * from "./5-in-1-water-sports-in-goa.vue?vue&type=script&lang=js"
import style0 from "./5-in-1-water-sports-in-goa.vue?vue&type=style&index=0&id=03a9f36e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03a9f36e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MainCategoryCard: require('/workspace/components/MainCategoryCard.vue').default,PopularCategoryCard: require('/workspace/components/PopularCategoryCard.vue').default,FaqCard: require('/workspace/components/FaqCard.vue').default})
